<template>
  <div class="px-9 sm:px-14 md:px-32 xl:px-56 py-9 md:py-20 flex-col-grow">
    <div class="bg-image brand-img message-brand"></div>
    <div class="py-8 flex-col-grow">
      <transition name="fade-in-up" appear>
        <div class="flex-col-grow items-center">
          <div class="w-full">
            <h1 class="text-center font-medium text-2xl text-base-color-alt">
              Pago Express
            </h1>
            <div v-if="creditorName" class="my-6 lg:my-3 flex justify-between">
              <CreditorInfo
                :creditor-name="creditorName"
                :creditor-tax-id="creditorTaxId"
              />
            </div>
            <div v-if="creditorName" class="h-6 lg:h-3"></div>
          </div>
          <div
            class="
              w-full
              my-1
              lg:my-6
              flex-col-grow
              items-center
              justify-center
            "
          >
            <div class="mt-6 mb-10 bg-image lg:mb-8 brand-img-message"></div>
            <div class="messages-container">
              <p
                v-for="message in messages"
                :key="message"
                class="text-base-color-alt"
              >
                {{ message }}
              </p>
            </div>
          </div>

          <!--div class="hidden sm:block lg:hidden">
          <div class="bg-image brand-img-alt"></div>
        </div-->
        </div>
      </transition>
    </div>
  </div>
  <div class="hidden w-full h-16 bg-gray brand-banner"></div>
</template>

<style lang="scss">
.messages-container {
  display: flex;
  flex-direction: column;
  align-items: center;

  p {
    margin: 0;
    text-align: center;
    font-size: 24px;
    line-height: 30px;
    letter-spacing: -0.01em;
    color: #1b2a4e;
    white-space: nowrap;
  }

  p:not(:first-child):not(:last-child) {
    margin-bottom: 0.75rem;
  }

  p:last-child {
    font-size: 14px;
    line-height: 18px;
    color: #869ab8;
    letter-spacing: 0;
    white-space: normal;
  }

  @media (min-width: 1024px) {
    p {
      font-size: 30px;
      line-height: 40px;
    }
    p:last-child {
      font-size: 16px;
      line-height: 20px;
    }
  }
}
</style>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import { inject } from "@vue/runtime-core";
import CreditorInfo from "@/components/CreditorInfo.vue";
import { VouchersService, VOUCHER_SERVICE } from "@/services/vouchers-service";

@Options({
  components: {
    CreditorInfo,
  },
  props: {
    messages: {
      type: Array,
      require: true,
    },
  },
})
export default class MessageView extends Vue {
  creditorName!: string | undefined;
  creditorTaxId!: string;
  private voucherService!: VouchersService;

  beforeCreate(): void {
    const voucherService = inject<VouchersService>(VOUCHER_SERVICE);
    if (voucherService) {
      this.voucherService = voucherService as VouchersService;
      this.creditorName = this.voucherService.getCreditorName();
      this.creditorTaxId = this.voucherService.getCreditorTaxId();
    }
  }
}
</script>
